export default __webpack_public_path__ + "static/rubric_D-a0e3714091668fe7eb4061e577385b9c.png";